import React, {Component} from 'react';
import './NavListItem.css';
import RouteLink from './RouteLink';

class NavListItem extends Component {
	render() {
		const {path, to, name, status, suffix, children, backgroundUrl, theme = 'green', disabled} = this.props;
		
		return (
			<RouteLink disabled={disabled} className={`NavListItem ${backgroundUrl ? '' : 'no-bg'} ${theme}`} path={path} to={to}>
				{backgroundUrl ? (<div className="NavListItem-cover" style={{backgroundImage: `url('${backgroundUrl}')`}} />) : undefined}
				<div className="NavListItem-details">
					<div className="NavListItem-name">{name}</div>
					<div className="NavListItem-status">{status}</div>
					<div className="NavListItem-extra">{children}</div>
				</div>
				{suffix ? (
					<div className="NavListItem-suffix">
						{suffix}
					</div>
				) : undefined}
			</RouteLink>
		);
	}
}

export default NavListItem;


// WEBPACK FOOTER //
// ./src/widgets/NavListItem.js